import React, { useEffect, useRef, useState } from 'react';
import { Button, Form } from 'react-bootstrap';

import { api_gateway } from '../../../conexoes/api';
import { setaDropdown } from '../../../utils/alternanciaIcones';
import SpinerVeye from '../../spinnerVeye/spinnerVeye.js';
export default function SelectFatOperadora(props) {
    const [spinAtivo, setSpinAtivo] = useState(false);
    const [lsOperadora, setLsOperadora] = useState([])
    const modal = useRef();

    const handleClickFora = e => {
        if (!modal.current.contains(e.target)) {
            handleCancelar()
        }
    };

    function handleOperadora(Codigo, Operadora){
        props.setCdOperadora(Codigo)
        props.setDsOperadora(Operadora)
        handleCancelar()
    }

    function handleCancelar(){
        props.setRevelarSelectFornecedorOperadora(false)
    }

    useEffect(() => {
        setSpinAtivo(true)
        async function renderOperadora(){
            
            const {data} = await api_gateway.get('/m1/consultar/fat_operadora/operadora_por_fornecedor?cd_fat_fornecedor='+props.cdFornecedor);
            if(data.dados.length > 0){
                let objetoOperadora = data.dados.map((item,i) => {
                    return (
                        <li key={"menu-"+item.cd_dsp_operadora}>
                            <div className="campo-select-opcao campo-select-opcao-1" onClick={() => handleOperadora(item.cd_dsp_operadora, item.ds_apelido) }>
                                <span className="fonte-cor-1 fonte-campo campo-select-opcao-label campo-select-operadora-sms nao-selecionavel">{item.ds_apelido}</span>
                            </div>
                            {data.dados[i+1]!=undefined&&<div className="campo-select-divisor-cor-1 campo-select-divisor" />}
                        </li>
                    );
                })
                setLsOperadora(objetoOperadora)
            }else{
                let objetoOperadora = () => {
                    return (
                        <li>
                            <div disabled className="campo-select-opcao campo-select-opcao-1">
                                <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">Nenhuma informação encontrada</span>
                            </div>
                        </li>
                    );
                }
                setLsOperadora(objetoOperadora)
            }
            setSpinAtivo(false)
        }
        renderOperadora()
        document.addEventListener('mousedown', handleClickFora);
        return () => document.removeEventListener('mousedown', handleClickFora);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return(
        <Form ref={modal}>
            { spinAtivo && <div className="componente-spinner-overlay"><div className="componente-spinner-container"><SpinerVeye/></div></div> }
            <Button name="cdTipoPessoa" className="campo-texto-cor-3 campo-select" onClick={() => props.setRevelarSelectFornecedorOperadora(false)}>
                <div className="fonte-cor-1 label-campo">{props.dsOperadora}</div>
                <img className="campo-select-icone-ativado" src={setaDropdown()} alt="drop" />
            </Button>
            <div className="campo-select-triangulo-cor-1 campo-select-triangulo" />
            <div className="campo-texto-cor-3 campo-select-corpo">
                <ul className="campo-select-lista">
                    {lsOperadora}
                </ul>
            </div>
        </Form>
    )
}